export default class EstatedAddress {
  constructor(obj) {
    this.fips = obj.fips;
    this.apn = obj.apn;
    this.street_number = obj.street_number;
    this.street_pre_direction = obj.street_pre_direction;
    this.street_name = obj.street_name;
    this.street_suffix = obj.street_suffix;
    this.street_post_direction = obj.street_post_direction;
    this.unit_type = obj.unit_type;
    this.unit_number = obj.unit_number;
    this.formatted_street_address = obj.formatted_street_address;
    this.city = obj.city;
    this.state = obj.state;
    this.zip_code = obj.zip_code;
    this.zip_plus_four_code = obj.zip_plus_four_code;
    this.carrier_code = obj.carrier_code;
    this.latitude = obj.latitude;
    this.longitude = obj.longitude;
    this.geocoding_accuracy = obj.geocoding_accuracy;
    this.census_tract = obj.census_tract;
    this.county = null;
  }

  get placeName() {
    return `${this.formatted_street_address}, ${this.city}, ${this.state} ${this.zip_code}`;
  }
}
